// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {
    // Advanced search form filters
    initListingModals();
}]);

window.initModalClicks = function initModalClicks() {

    // dismiss modals first
    $('.modal-change-content').on('click', function(e) {
        let modalBtn = $(this);
        let currentModal = $(modalBtn.attr('href'));
        let endpoint = modalBtn.data('remote-endpoint');
        let modalTitle = modalBtn.data('modal-title');
        let baseModal = currentModal;

        // fade modal content
        currentModal.find('.modal-title').fadeOut('fast');
        currentModal.find('.modal-body').fadeOut('fast', function() {
            ajaxModal(currentModal, endpoint, modalTitle, baseModal, function() {
                currentModal.find('.modal-title').fadeIn('fast');
                currentModal.find('.modal-body').fadeIn('fast');
            });
        });
    });
}

window.ajaxModal = function ajaxModal(currentModal, endpoint, modalTitle, baseModal, callback) {
    $.ajax({
        url: endpoint,
        success: function(response) {
            baseModal.find('.modal-body').html(response);
            baseModal.find('.modal-title').html(modalTitle);
        }
    }).done(function(response) {
        initWeeklyPrices('#modal-base');
        initModalSelects();
        initModalValidate();
        initModalClicks();

        initPhoneInputs();

        // currentModal.find('.selectpicker').selectpicker({
        //     style: 'btn-select',
        //     iconBase: 'fa',
        //     tickIcon: 'fa-check',
        //     mobile: isMobileSelect
        // });

        currentModal.find('.datepicker').datepicker({
            startDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            format: 'dd/mm/yyyy',
            autoclose: true,
            container: '#modal-base .date',
            orientation: 'top left',
        }).on('show', function(e) {
            e.stopPropagation();
        }).on('hide', function(e) {
            e.stopPropagation();
        });

        if (currentModal.find('.modal-dealer').length) {
            $.getScript("/js/utils/gmap.js", function(data, textStatus, jqxhr) {
                //console.log('got gmap script');
                // trigger dealer to show with map
                let branchId = currentModal.find('.modal-dealer').data('current_branch_id');
                let currentBranch = $('#modal-base').find('.branch-details#branch_' + branchId);

                if (currentBranch.length) {
                    let mapBranch = $('.modal-dealer #branch-map');
                    mapBranch.attr('data-lat', currentBranch.data('lat'));
                    mapBranch.attr('data-lon', currentBranch.data('lon'));
                    mapBranch.attr('data-zoom', currentBranch.data('zoom'));
                    mapBranch.attr('data-branch_id', currentBranch.data('branch_id'));

                    initializeModalLocationDetailsMap(currentBranch);
                }
            });
        }

        // re-init captcha
        window.recaptchaInit('#modal-base');

        if (typeof callback === 'function') {
            callback();
        }
    });
}

let footerLinks = $('.footer-vehicle-links');

window.initListingModals = function initListingModals() {
    // base modal trigger
    $('a[href="#modal-base"], button[href="#modal-base"]').on('click', function(e) {

        e.preventDefault();

        let currentModal = $("#modal-base");
        let currentButton = $(this);
        let modalShown = currentModal.hasClass('in');
        if ($(currentButton).data('remote-endpoint')) {

            let endpoint = $(currentButton).data('remote-endpoint');
            let modalTitle = $(currentButton).data('modal-title');
            let baseModal = currentModal;

            // if base modal is already visible ajax load new content
            if (modalShown === true) {
                // fade modal content
                currentModal.find('.modal-title').fadeOut('fast');
                currentModal.find('.modal-body').fadeOut('fast', function() {
                    ajaxModal(currentModal, endpoint, modalTitle, baseModal, function() {
                        currentModal.find('.modal-title').fadeIn('fast');
                        currentModal.find('.modal-body').fadeIn('fast');
                    });
                });
            } else {
                ajaxModal(currentModal, endpoint, modalTitle, baseModal, function() {
                    currentModal.modal('show');
                });
            }
        }

        if(footerLinks.length > 0) {
            footerLinks.find('a[data-toggle=modal]').removeClass('active disabled');
            currentButton.addClass('active');
        }
    });

    // click trigger to reset footer links
    $('.modal button.close').on('click', function(e) {
        footerLinks.find('a').removeClass('active');
    });

    // clear base modal on close
    $('#modal-base').on('hide.bs.modal', function (e) {
        $(this).find('.modal-body').html('');
        $(this).find('.modal-title').html('');
        footerLinks.find('a[href="#modal-base"]').removeClass('active');
    });

    // sign in modal
    $('#signin-modal').on('show.bs.modal', function (e) {
        if(footerLinks.length > 0) {
            footerLinks.find('a[data-toggle=modal]').removeClass('active disabled');
            footerLinks.find('a[href="#signin-modal"]').addClass('active');
        }
    });

    $('#signin-modal').on('hidden.bs.modal', function (e) {
        footerLinks.find('a[href="#signin-modal"]').removeClass('active');
    });

    // slide modals callbacks
    $('.modalSlide').on('show.bs.modal', function (e) {
        showBsModals();
    });

    $('.modalSlide').on('hidden.bs.modal', function (e) {
        hideBsModals();
    });
}

window.initModalSelects = function initModalSelects() {
    // branch change for dealership / call modals
    $('#call-dealership').on('change', function() {
        let branchId = $('option:selected', this).attr("data-branch_id");
        $('#modal-base').find('.branch-details').hide();

        // show current selected branch
        let currentBranch = $('#modal-base').find('.branch-details#branch_' + branchId);
        currentBranch.show();

        // google map for dealer modal
        if ($('#modal-base').find('.modal-dealer').length) {
            let mapBranch = $('.modal-dealer #branch-map');
            mapBranch.attr('data-lat', currentBranch.data('lat'));
            mapBranch.attr('data-lon', currentBranch.data('lon'));
            mapBranch.attr('data-zoom', currentBranch.data('zoom'));
            mapBranch.attr('data-branch_id', currentBranch.data('branch_id'));

            // init map
            if (branchId) {
                initializeModalLocationDetailsMap(currentBranch);
            } else {
                // hide the map if select is empty
                mapBranch.html('');
            }
        }
    });

    // enquiry type change
    $('#form-enquiry-testdrive #enquire-action').on('change', function() {
        let enquiryType = $('option:selected', this).val();
        let form = $('#form-enquiry-testdrive');

        // hide all sections first
        form.find('.enquire-action').addClass('hidden');

        // show relevent section
        form.find('#enquire-action-' + enquiryType).removeClass('hidden');

        switch (enquiryType) {
            case 'testdrive':
            default:
                form.attr('data-fname', 'testdrive');
                form.find('input[name="saction"]').val('SENDTESTDRIVEMODAL');
                form.find('input[name="form_key"]').val('testdriveForm');
                form.find('button[type="submit"]').text('Book test drive');
                break;
            case 'enquirenow':
                form.attr('data-fname', 'enquiry');
                form.find('input[name="saction"]').val('SENDENQUIRYMODAL');
                form.find('input[name="form_key"]').val('listingContactDealerForm');
                form.find('button[type="submit"]').text('Submit enquiry');
                break;
            }
    });
}

window.showBsModals = function showBsModals() {

    // hide other modals
    $('.modalSlide').not($(this)).modal('hide');

    // html class
    $('html').addClass('modal-slides');

    // stick header / footer
    if (!$('#mob-header').hasClass('headroom--top')) {
        $('#mob-header').addClass('headroom--pinned').removeClass('headroom--unpinned');
    }
    // if (!$('#footroom').hasClass('footroom--top')) {
    //     $('#footroom').addClass('footroom--pinned').removeClass('footroom--unpinned');
    // }

    // put sticky height objects back into position
    // $('.compare-action').addClass('higher');
    $('.listings-search--container').addClass('lower');
}

window.hideBsModals = function hideBsModals() {

    // toggle html class, only if other modals haven't been opened
    $('html').removeClass('modal-slides');
    $('.modal').each(function(e) {
        if ($(this).hasClass('in')) {
            $('html').addClass('modal-slides');
            return false;
        }
    });

    // stick header / footer
    // if (!$('#mob-header').hasClass('headroom--top')) {
    //     $('#mob-header').addClass('headroom--unpinned').removeClass('headroom--pinned');

    //     // reset search bar if not in top
    //     $('.listings-search--container').removeClass('lower');
    // }
    // if (!$('#footroom').hasClass('footroom--top')) {
    //     $('#footroom').addClass('footroom--unpinned').removeClass('footroom--pinned');
    // }

    // put sticky height objects back into position
    // $('.compare-action').removeClass('higher');
}